import * as React from "react";
import type { SVGProps } from "react";
const SvgPower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.067 5.933a1 1 0 1 0-1.414 1.414zm-7.072 16.07v1zM6.337 7.347a1 1 0 1 0-1.414-1.414zM13 2a1 1 0 1 0-2 0zm-2 10a1 1 0 1 0 2 0zm6.653-4.653a8 8 0 0 1 2.189 4.096l1.961-.39a10 10 0 0 0-2.736-5.12zm2.189 4.096a8 8 0 0 1-.456 4.622l1.848.765a10 10 0 0 0 .57-5.777zm-.456 4.622a8 8 0 0 1-2.947 3.59l1.111 1.663a10 10 0 0 0 3.683-4.488zm-2.947 3.59a8 8 0 0 1-4.444 1.348v2a10 10 0 0 0 5.555-1.685zm-4.444 1.348a8 8 0 0 1-4.444-1.348L6.44 21.318a10 10 0 0 0 5.555 1.685zm-4.444-1.348a8 8 0 0 1-2.947-3.59l-1.847.765a10 10 0 0 0 3.683 4.488zm-2.947-3.59a8 8 0 0 1-.455-4.622l-1.962-.39a10 10 0 0 0 .57 5.778zm-.455-4.622a8 8 0 0 1 2.188-4.096L4.923 5.933a10 10 0 0 0-2.736 5.12zM11 2v10h2V2z"
    />
  </svg>
);
export default SvgPower;
